import { BaseContainer } from '@components/BaseContainer';
import styled from '@emotion/styled';

export const Container = styled(BaseContainer)`
  padding: 0 20px;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
`;

export const Title = styled.div`
  color: #fff;
  font-size: 32px;
  font-family: NokiaPureHeadline-Bold;
  text-align: center;
`;
